export default __webpack_public_path__ + "static/media/gold 1 d (1).38b36204.png";